namespace SP {
    export enum StatGroup {
        MonthInYear = 0,
        DayInMonth = 1,
        HourInDay = 2,
        WeekDay = 3,
        Hour = 4,
        Day = 5,
        Week = 6,
        Month = 7,
        Year = 8
    }
}